<template>
    <Modal v-model="show"
        title="账号信息"
        :width="60"
        @on-visible-change="onShowChange">
        <Spin v-if="$globalSpin"
            size="large"
            fix></Spin>
        <Form ref="userHrForm"
            :model="userHrForm"
            :rules="ruleValidate"
            label-position="top"
            class="small-form">

            <Row :gutter="16">
                <Col span="6">
                <FormItem label="登录帐号"
                    prop="userName">
                    <Input v-model="userHrForm.userName"
                        :readonly="formEditMode===FORM_EDIT_MODE_MODIFY"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="姓名"
                    prop="userHrName">
                    <Input v-model="userHrForm.userHrName"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="手机"
                    prop="userHrPhone">
                    <Input v-model="userHrForm.userHrPhone"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="审批">
                    <RadioGroup v-model="userHrForm.userHrApproval"
                        type="button">
                        <Radio v-for="item in approvalSource"
                            :key="item.val"
                            :label="item.val">{{ item.label }}
                        </Radio>
                    </RadioGroup>
                </FormItem>
                </Col>
            </Row>
            <!-- <Row :gutter="16">
                <Col span="6">
                <FormItem label="主账号">
                    <RadioGroup v-model="userHrForm.isPrimaryAccount"
                        type="button">
                        <Radio v-for="item in primaryAccountSource"
                            :key="item.val"
                            :label="item.val">{{ item.label }}
                        </Radio>
                    </RadioGroup>
                </FormItem>
                </Col>
            </Row> -->
            <Row :gutter="16">
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码">
                    <Input v-model="password"
                        type="password"></Input>
                </FormItem>
                </Col>
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码确认">
                    <Input v-model="passwordConfirm"
                        type="password"></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="primary"
                @click="onSave">确认</Button>
            <Button type="error"
                @click="show=false">取消</Button>
        </div>
    </Modal>
</template>

<script>
import { APPROVAL_NO, APPROVAL_YES, approvalFormat } from '@/libs/baseModelFormat';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';

import { HrUserSave, getHrUserDetail } from '@/api/modules/account-management/hr-user-management';

export default {
    name: 'HrUserEdit',
    data() {
        return {
            show: false,
            accountUuid: '',
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            userHrForm: {
                userHrLoginUuid: '',
                userName: '',
                userHrName: '',
                userHrContactNumber: '',
                userHrPhone: '',
                userHrWechat: '',
                userHrEmail: '',
                //   isPrimaryAccount:0,
                userHrApproval: APPROVAL_NO
            },
            ruleValidate: {
                userName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length >= 3 && value.length <= 20) {
                                    callback();
                                }
                                else {
                                    callback(new Error('长度在3-20个字符之间'));
                                }
                            }
                            else {
                                callback(new Error(' '));
                            }
                        }
                    }
                ],
                userHrName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length >= 2 && value.length <= 20) {
                                    callback();
                                }
                                else {
                                    callback(new Error('长度在2-20个字符之间'));
                                }
                            }
                            else {
                                callback(new Error(' '));
                            }
                        }
                    }
                ],
                userHrPhone: [
                    { pattern:/^(?:(?:\+|00)86)?1\d{10}$/, required: true, message: '手机号码格式不正确1 ', trigger: 'change' }
                ]
            },
            password: '',
            passwordConfirm: '',
            approvalSource: [],
            primaryAccountSource: []
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(accountUuid) {
            this.accountUuid = accountUuid;
            this.show = true;
        },
        init() {
            this.approvalSource = [];
            this.approvalSource.push({ val: APPROVAL_NO, label: approvalFormat(APPROVAL_NO) });
            this.approvalSource.push({ val: APPROVAL_YES, label: approvalFormat(APPROVAL_YES) });
            this.primaryAccountSource = [ { val: 0, label: "子账号" }, { val: 1, label: "主账号" }]; 

            // const query = this.$route.query;
            if (this.accountUuid) {
                this.formEditMode = FORM_EDIT_MODE_MODIFY;

                // this.$showGlobalSpin();
                getHrUserDetail(this.accountUuid).then(res => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        const info = res.data.userHr;
                        this.userHrForm.userHrLoginUuid = info.userHrLoginUuid;
                        this.userHrForm.userName = info.userName;
                        this.userHrForm.userHrName = info.userHrName;
                        this.userHrForm.userHrContactNumber = info.userHrContactNumber;
                        this.userHrForm.userHrPhone = info.userHrPhone;
                        this.userHrForm.userHrWechat = info.userHrWechat;
                        this.userHrForm.userHrEmail = info.userHrEmail;
                        this.userHrForm.userHrApproval = info.userHrApproval;
                        //  this.userHrForm.isPrimaryAccount = info.isPrimaryAccount;
                    }
                }).catch(() => {
                    this.$hideGlobalSpin();
                });
            }
            else {
                this.$refs.userHrForm.resetFields();
            }
        },
        onSave() {
            this.$refs.userHrForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }

                const data = Object.assign({ formEditMode: this.formEditMode }, this.userHrForm);
                if (this.formEditMode === FORM_EDIT_MODE_CREATE) {
                    data.password = this.password;
                    data.passwordConfirm = this.passwordConfirm;
                }

                this.$showGlobalSpin();
                HrUserSave(data).then(res => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            onOk: () => {
                                this.show = false;
                                this.$parent.getHrUserTableRecords();
                            }
                        });
                    }
                });
            });
        }
    }
};
</script>

<style scoped>
</style>
